module.exports = __webpack_public_path__ + "static/media/more-all-products-8.6f85a396.png";